import * as React from 'react'
import { useMemo } from 'react'

// Components
import Field from '@components/Field'

const getPreReqField = (fields: any, preReqField: any) => {
  if (!fields || !preReqField) return null

  const hasPurchaseInformation = Object.hasOwn(fields, 'purchaseInformation')

  if (hasPurchaseInformation) {
    if (preReqField === 'productId') {
      const nestedProductId = fields['purchaseInformation']?.value?.[0]?.fields?.purchaseItems?.value?.[0]?.fields?.productId

      if (nestedProductId) return nestedProductId

      return { value: '' }
    }
  }

  return fields[preReqField] ?? null
}

const FormField = (props: any) => {
  const { options, fields, ...other } = props
  const preReqField = getPreReqField(fields, props.preReqField)

  const preReqOptions = useMemo((): any => {
    if (!options) return null

    return options.filter((option: any) => {
      if (!option.prereq || !preReqField) return true

      return new RegExp(option.prereq.value, 'gi').test(preReqField.value)
    })
  }, [preReqField, options])

  return <Field {...other} options={preReqOptions} />
}

export default FormField
